<input
  #trackUploadFileInput
  type="file"
  [accept]="accept"
  [multiple]="true"
  (change)="onFileSelect($event)"
  class="input-file"
/>
<div
  [matTooltip]="'MEDIA.ACTIONS.DISK_SPACE_EXCEEDED' | translate"
  [matTooltipDisabled]="canUpload$ | async"
  [matTooltipPosition]="'above'"
  class="hidden md:block"
>
  <rk-button
    [label]="'MEDIA.ACTIONS.ADD_TRACKS' | translate"
    faIcon="fa-plus"
    (click)="selectTrack()"
    [disabled]="!(canUpload$ | async)"
    data-tour="upload"
    [pulse]="pulse"
  ></rk-button>
  <rk-animated-arrow
    *ngIf="pulse"
    [description]="'CHECKLIST.ARROW.UPLOAD_DESCRIPTION' | translate"
  ></rk-animated-arrow>
</div>

<rk-mobile-fab-button
  *ngIf="canUpload$ | async"
  (click)="selectTrack()"
></rk-mobile-fab-button>
